import { createContext, createElement, useContext, useMemo, useState, useEffect } from 'react'
import { useAppContext } from 'app/app-context/app-context'
import { useRequireUserContext } from './require-user-context'

interface ITheme {
  backgroundColor: string
  logo: string
}

interface IThemeContext {
  theme: ITheme | undefined
}

const ThemeContext = createContext<IThemeContext>({} as IThemeContext)

export const useThemeContext = () => {
  return useContext(ThemeContext)
}

export const ThemeContextProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<ITheme | undefined>(undefined)
  const { currentCommunity, currentCompany, isCommunityAdmin, isCompanyAdmin } = useAppContext()
  const { currentUser } = useRequireUserContext()

  useEffect(() => {
    const isAdmin = currentUser?.isGlobalAdmin || isCommunityAdmin || isCompanyAdmin

    if (currentCommunity && !currentCompany) {
      setTheme({
        backgroundColor: currentCommunity.primaryColor,
        logo: currentCommunity.logo
      })
    } else if (currentCommunity && currentCompany) {

      setTheme({
        backgroundColor: isAdmin ? currentCommunity.primaryColor : currentCompany.primaryColor || currentCommunity.primaryColor,
        logo: isAdmin ? currentCommunity.logo : currentCompany.logo || currentCommunity.logo
      })
    } else {
      setTheme(undefined)
    }
  }, [currentCommunity, currentCompany, currentUser, isCommunityAdmin])

  const themeValue = useMemo(() => ({ theme }), [theme])
  return createElement(ThemeContext.Provider, { value: { ...themeValue } }, children)
}
